import { render, staticRenderFns } from "./PointTransaction.vue?vue&type=template&id=0898a411&scoped=true"
import script from "./PointTransaction.vue?vue&type=script&lang=js"
export * from "./PointTransaction.vue?vue&type=script&lang=js"
import style0 from "./PointTransaction.vue?vue&type=style&index=0&id=0898a411&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0898a411",
  null
  
)

export default component.exports